import { useState } from "react";
import { buildEdgesComStyle } from "../templates/templateUtils";

// Hook para gerenciar aplicação de templates e confirmações do diagrama
export default function useAplicarTemplate({
  nodes = [],
  setNodes = () => {},
  setEdges = () => {},
  setSelectedNodeId = () => {},
  setSelectedEdgeId = () => {},
  historyRef = { current: [] },
  redoRef = { current: [] },
  limparAnexosNodesRemovidos = () => {},
  semearComoCarregado = () => {},
  theme = {},
  setSnackbar = () => {},
}) {
  // Controle de abertura dos modais de template
  const [templatesModalOpen, setTemplatesModalOpen] = useState(false);
  const [salvarTemplateModalOpen, setSalvarTemplateModalOpen] = useState(false);
  const [templateAplicarConfirm, setTemplateAplicarConfirm] = useState(null);

  // Executa a substituição do diagrama pelo template com limpeza em cascata de anexos
  const executarAplicacaoTemplate = (template) => {
    limparAnexosNodesRemovidos?.(nodes || []);
    setNodes?.((template?.dados?.nodes || []).map((node) => ({ ...node })));
    setEdges?.(buildEdgesComStyle(template?.dados?.edges || [], theme));
    // Semeia os nós do template como já carregados para evitar refetch sob demanda
    const idsNodesTemplate = (template?.dados?.nodes || [])
      .map((node) => node?.id)
      .filter(Boolean);
    semearComoCarregado?.(idsNodesTemplate);
    setSelectedNodeId?.(null);
    setSelectedEdgeId?.(null);
    setTemplateAplicarConfirm(null);
    // Limpa o histórico de desfazer e refazer pois aplicação de template é irreversível
    if (historyRef) historyRef.current = [];
    if (redoRef) redoRef.current = [];
    setSnackbar?.({ children: "Template aplicado.", severity: "success" });
  };

  // Solicita confirmação se houver nós no canvas antes de substituir pelo template
  const aplicarTemplate = (template) => {
    if (!template) return;
    if ((nodes?.length || 0) > 0) {
      setTemplateAplicarConfirm(template);
      return;
    }
    executarAplicacaoTemplate(template);
  };

  return {
    templatesModalOpen,
    setTemplatesModalOpen,
    salvarTemplateModalOpen,
    setSalvarTemplateModalOpen,
    templateAplicarConfirm,
    setTemplateAplicarConfirm,
    aplicarTemplate,
    executarAplicacaoTemplate,
  };
}
